{
  "MFA_SETTINGS": {
    "TITLE": "Autenticação em Dois Fatores",
    "SUBTITLE": "Proteja sua conta contra acessos não autorizados com autenticação baseada em TOTP. Isso adiciona uma camada extra de segurança à sua conta.",
    "DESCRIPTION": "Adicione uma camada extra de segurança à sua conta usando uma senha temporária baseada em tempo (TOTP)",
    "STATUS_TITLE": "Estado da Autenticação",
    "STATUS_DESCRIPTION": "Gerencie as configurações de autenticação em dois fatores e os códigos de recuperação",
    "ENABLED": "Ativado",
    "DISABLED": "Desativado",
    "STATUS_ENABLED": "A autenticação em dois fatores está ativa",
    "STATUS_ENABLED_DESC": "Sua conta está protegida com uma camada extra de segurança",
    "ENABLE_BUTTON": "Habilitar autenticação em dois fatores",
    "ENHANCE_SECURITY": "Reforce a Segurança da Sua Conta",
    "ENHANCE_SECURITY_DESC": "A autenticação em dois fatores adiciona uma camada extra de segurança ao exigir um código de verificação do seu aplicativo autenticador, além da sua senha.",
    "SETUP": {
      "STEP_NUMBER_1": "1",
      "STEP_NUMBER_2": "2",
      "STEP1_TITLE": "Escaneie o Código QR com seu Aplicativo Autenticador",
      "STEP1_DESCRIPTION": "Use o Google Authenticator, Authy ou qualquer outro aplicativo compatível com TOTP",
      "LOADING_QR": "Carregando...",
      "MANUAL_ENTRY": "Não consegue escanear? Digite o código manualmente",
      "SECRET_KEY": "Chave secreta",
      "COPY": "Copiar",
      "ENTER_CODE": "Insira o código de 6 dígitos do seu aplicativo autenticador",
      "ENTER_CODE_PLACEHOLDER": "000000",
      "VERIFY_BUTTON": "Verificar e Continuar",
      "CANCEL": "Cancelar",
      "ERROR_STARTING": "O MFA não está habilitado. Entre em contato com o administrador.",
      "INVALID_CODE": "Código de verificação inválido",
      "SECRET_COPIED": "Chave secreta copiada para a área de transferência",
      "SUCCESS": "A autenticação em dois fatores foi ativada com sucesso"
    },
    "BACKUP": {
      "TITLE": "Salve Seus Códigos de Recuperação",
      "DESCRIPTION": "Guarde esses códigos com segurança. Cada um pode ser usado uma única vez caso você perca o acesso ao seu aplicativo autenticador",
      "IMPORTANT": "Importante:",
      "IMPORTANT_NOTE": " Salve esses códigos em um local seguro. Você não poderá vê-los novamente.",
      "DOWNLOAD": "Baixar",
      "COPY_ALL": "Copiar Todos",
      "CONFIRM": "Salvei meus códigos de recuperação em um local seguro e entendo que não poderei vê-los novamente",
      "COMPLETE_SETUP": "Finalizar Configuração",
      "CODES_COPIED": "Códigos de recuperação copiados para a área de transferência"
    },
    "MANAGEMENT": {
      "BACKUP_CODES": "Códigos de Recuperação",
      "BACKUP_CODES_DESC": "Gere novos códigos caso tenha perdido ou já utilizado os códigos existentes",
      "REGENERATE": "Gerar novos códigos de recuperação",
      "DISABLE_MFA": "Desabilitar 2FA",
      "DISABLE_MFA_DESC": "Remover a autenticação em dois fatores da sua conta",
      "DISABLE_BUTTON": "Desabilitar Autenticação em Dois Fatores"
    },
    "DISABLE": {
      "TITLE": "Desabilitar Autenticação em Dois Fatores",
      "DESCRIPTION": "Você precisará informar sua senha e um código de verificação para desativar a autenticação em dois fatores.",
      "PASSWORD": "Senha",
      "OTP_CODE": "Código de Verificação",
      "OTP_CODE_PLACEHOLDER": "000000",
      "BACKUP_CODE": "Código de Recuperação",
      "BACKUP_CODE_PLACEHOLDER": "Insira um dos seus códigos de recuperação",
      "USE_BACKUP_CODE": "Perdeu o acesso ao seu autenticador? Use um código de recuperação em vez disso",
      "USE_OTP_CODE": "Use um código de verificação do seu aplicativo de autenticação",
      "CONFIRM": "Desabilitar 2FA",
      "CANCEL": "Cancelar",
      "SUCCESS": "A autenticação em dois fatores foi desabilitada",
      "ERROR": "Falha ao desabilitar o MFA. Verifique suas credenciais."
    },
    "REGENERATE": {
      "TITLE": "Gerar Novos Códigos de Recuperação",
      "DESCRIPTION": "Isso invalidará seus códigos de recuperação atuais e gerará novos. Informe o código de verificação para continuar.",
      "OTP_CODE": "Código de Verificação",
      "OTP_CODE_PLACEHOLDER": "000000",
      "CONFIRM": "Gerar Novos Códigos",
      "CANCEL": "Cancelar",
      "NEW_CODES_TITLE": "Novos Códigos de Recuperação Gerados",
      "NEW_CODES_DESC": "Seus códigos de recuperação antigos foram invalidados. Salve estes novos códigos em um local seguro.",
      "CODES_IMPORTANT": "Importante:",
      "CODES_IMPORTANT_NOTE": " Cada código só pode ser usado apenas uma vez. Salve-os antes de fechar esta janela.",
      "DOWNLOAD_CODES": "Baixar Códigos",
      "COPY_ALL_CODES": "Copiar Todos os Códigos",
      "CODES_SAVED": "Eu Já Salvei Meus Códigos",
      "SUCCESS": "Novos códigos de recuperação foram gerados",
      "ERROR": "Falha ao gerar novos códigos de recuperação"
    }
  },
  "MFA_VERIFICATION": {
    "TITLE": "Autenticação em Dois Fatores",
    "DESCRIPTION": "Informe o código de verificação para continuar",
    "AUTHENTICATOR_APP": "Aplicativo Autenticador",
    "BACKUP_CODE": "Código de Recuperação",
    "ENTER_OTP_CODE": "Insira o código de 6 dígitos do seu aplicativo autenticador",
    "ENTER_BACKUP_CODE": "Insira um dos seus códigos de recuperação",
    "BACKUP_CODE_PLACEHOLDER": "000000",
    "VERIFY_BUTTON": "Verificar",
    "TRY_ANOTHER_METHOD": "Tentar outro método de verificação",
    "CANCEL_LOGIN": "Cancelar e voltar para o login",
    "HELP_TEXT": "Está com dificuldade para entrar?",
    "LEARN_MORE": "Saiba mais sobre o 2FA",
    "HELP_MODAL": {
      "TITLE": "Ajuda com Autenticação em Dois Fatores",
      "AUTHENTICATOR_TITLE": "Usando um Aplicativo de Autenticação",
      "AUTHENTICATOR_DESC": "Abra seu aplicativo autenticador (Google Authenticator, Authy etc.) e digite o código de 6 dígitos exibido para a sua conta.",
      "BACKUP_TITLE": "Usando um Código de Backup",
      "BACKUP_DESC": "Se você não tiver acesso ao seu aplicativo autenticador, pode usar um dos códigos de backup que salvou ao configurar o 2FA. Cada código só pode ser usado uma vez.",
      "CONTACT_TITLE": "Precisa de Mais Ajuda?",
      "CONTACT_DESC_CLOUD": "Se você perdeu o acesso tanto ao aplicativo autenticador quanto aos códigos de backup, entre em contato com o suporte do Chatwoot para obter ajuda.",
      "CONTACT_DESC_SELF_HOSTED": "Se você perdeu o acesso tanto ao aplicativo autenticador quanto aos códigos de backup, entre em contato com o administrador para obter ajuda."
    },
    "VERIFICATION_FAILED": "Falha na verificação. Tente novamente."
  }
}
